import config from 'app/config';
import { clientFetch } from 'utils/client-fetch';

export interface IssuanceReward {
    recognitionDistributionId: string;
    rewardId: string;
    value: string;
}

export interface CreateExchangePayload {
    personId: string;
    rewards: IssuanceReward[];
}

export interface CreateExchangesPayload {
    exchanges: CreateExchangePayload[];
}

interface ExchangeRewardResponse {
    id: string;
    personId: string;
    exchangeId: string;
    status: string; // 'SCHEDULED'
    type: 'POINTS';
    value: string;
    wrapperId: string;
    wrapperType: 'TOKEN';
    createdAt: string; // ISO-8601 date
}

interface ExchangeResponse {
    exchangeId: string;
    personId: string;
    rewards: ExchangeRewardResponse[];
}

export interface CreateRewardResponse {
    success: boolean;
    exchanges?: ExchangeResponse[];
    rewards?: ExchangeRewardResponse[];
    errors: unknown[];
}

export const createTokenUsingExchange = (payload: CreateExchangesPayload): Promise<CreateRewardResponse> =>
    clientFetch({
        url: `${config.EXCHANGE_API_URL}/rewards`,
        method: 'POST',
        body: payload
    });
